var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtTarget = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 84,
    viewBox: "0 0 56 84",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 82.754C56 83.33 45.366 84 33.113 84c-12.254 0-22.187-.467-22.187-1.044 0-.576 9.933-1.043 22.187-1.043 12.253 0 22.887.266 22.887.842v-.001z",
    fill: "#32323F",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.49.002c12.677.026 22.92 18.535 22.876 41.342C46.323 64.151 39.454 82.67 22.2 82.67 12.052 82.669.41 64.058.455 41.25.498 18.444 10.812-.023 23.49.001z",
    fill: "#7D1300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6 41.338c-.043 22.807-9.614 41.275-21.378 41.253-.063 0-.127 0-.19-.002a11.096 11.096 0 0 1-2.292-.281c-1.268-.288-2.504-.792-3.693-1.493-.14-.082-.277-.166-.415-.255C6.105 75.16-.034 59.598 0 41.253.043 18.446 9.615-.023 21.379 0c.338 0 .672.016 1.006.047 11.293 1.044 20.255 19.139 20.212 41.29h.003z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#CD2B31",
    transform: "rotate(-89.89 20.225 41.297)",
    cx: 20.225,
    cy: 41.297,
    rx: 36.497,
    ry: 18.825
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    transform: "rotate(-89.89 19.308 41.295)",
    cx: 19.308,
    cy: 41.295,
    rx: 29.711,
    ry: 15.324
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#CD2B31",
    transform: "rotate(-89.89 18.175 41.292)",
    cx: 18.175,
    cy: 41.292,
    rx: 24.1,
    ry: 12.432
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    transform: "rotate(-89.89 17.42 41.292)",
    cx: 17.42,
    cy: 41.292,
    rx: 16.137,
    ry: 8.323
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#CD2B31",
    transform: "rotate(-89.89 17.42 41.292)",
    cx: 17.42,
    cy: 41.292,
    rx: 8.13,
    ry: 4.194
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.955 38.337c-.467 1.139.957 2.354.041 4.72-.915 2.367 2.626-3.03 2.626-3.03L27.6 37.36l-1.648.978.002-.002z",
    fill: "#CD2B31"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 27.342,
    cy: 41.446,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.17 42.068s.898-.218.893-.477c-.003-.212-.912-.333-.912-.333l-4.997.365.018.81 4.997-.365z",
    fill: "#E7E7E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.497 41.32c-.127-.41-.485-.7-.894-.685l-6.143.23.022.494.069 1.568 6.143-.227c.497-.018.878-.48.853-1.03l-.004-.073a1.179 1.179 0 0 0-.047-.279l.001.002z",
    fill: "#E7E7E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.46 40.866-6.26.486c-.155.005-1.253.085-2.452.22-1.585.179-3.347.452-3.345.775v.003c.048.567 5.505.574 5.866.559l6.282.02-.07-1.568-.02-.494v-.001z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.01 42.177-6.398.239c-.018.024-.035.05-.051.076-.008.014-.018.028-.027.041a2.559 2.559 0 0 0-.288.665c-.25.902-.028 1.93.645 2.62.465.475 1.055.699 1.634.678.58-.022 1.148-.29 1.57-.797L6.18 43.18l.237-.287.592-.716z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.497 41.32c-.127-.41-.485-.7-.894-.685l-6.143.23-6.26.487c-.155.005-1.253.085-2.452.22l-.122.31 8.856-.523 1.957-.116s4.001-.105 5.057.075l.001.002z",
    fill: "#1F1F39",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.157 38.207c.58-.021 1.171.202 1.635.678l3.216 3.292-6.398.239c-.798-.962-.821-2.447-.023-3.412.42-.508.99-.776 1.57-.797z",
    fill: "#106275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.417 43.16c-1.967-.18-4.754-.529-5.856-.668l-.027.068a6.036 6.036 0 0 0-.288 1.108c.745-.226 1.583-.193 2.675-.152 1.11.043 2.73.038 3.259.122l.237-.479z",
    fill: "#1F1F39",
    opacity: 0.18
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtTarget);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-target.1c67db95af3878fee3e634f002cc7782.svg";